import { HelpCircle, Image as ImageIcon, FolderOpen, Share2 } from "lucide-react";
import { t } from "@/lib/i18n";
import { getPlatform } from "@/lib/device";

export default function WhereSavedHint({ onClose }) {
  const platform = getPlatform();
  // Body string per platform
  const bodyKey =
    platform === "ios"
      ? "hintIosBody"
      : platform === "android"
      ? "hintAndroidBody"
      : "hintDesktopBody";

  return (
    <div
      data-testid="where-saved-hint"
      className="fixed inset-0 z-[85] flex items-end sm:items-center justify-center"
    >
      {/* Backdrop */}
      <div
        data-testid="hint-backdrop"
        onClick={onClose}
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
      />

      {/* Sheet */}
      <div
        className="relative w-full sm:max-w-md mx-0 sm:mx-4 bg-zinc-900 border-t sm:border border-white/10 rounded-t-3xl sm:rounded-3xl shadow-[0_20px_60px_rgba(0,0,0,0.6)] slide-up overflow-hidden"
      >
        {/* Top handle */}
        <div className="flex justify-center pt-3 pb-1 sm:hidden">
          <div className="h-1 w-10 rounded-full bg-white/15" />
        </div>

        <div className="px-7 pt-6 pb-8 flex flex-col gap-5">
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-2xl bg-emerald-400/15 border border-emerald-400/30 flex items-center justify-center">
              <HelpCircle className="h-5 w-5 text-emerald-300" strokeWidth={1.8} />
            </div>
            <h2 className="font-display text-2xl font-light text-white tracking-tight">
              {t("hintTitle")}
            </h2>
          </div>

          <p className="text-sm text-white/75 leading-relaxed whitespace-pre-line">
            {t(bodyKey)}
          </p>

          <div className="flex flex-col gap-3 mt-1">
            <div className="flex items-start gap-3">
              <div className="h-8 w-8 rounded-full bg-white/8 border border-white/10 flex items-center justify-center shrink-0">
                <ImageIcon className="h-4 w-4 text-white/85" strokeWidth={1.8} />
              </div>
              <p className="text-xs text-white/65 leading-relaxed pt-1.5">
                {t("hintGalleryTip")}
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="h-8 w-8 rounded-full bg-white/8 border border-white/10 flex items-center justify-center shrink-0">
                <Share2 className="h-4 w-4 text-white/85" strokeWidth={1.8} />
              </div>
              <p className="text-xs text-white/65 leading-relaxed pt-1.5">
                {t("hintShareTip")}
              </p>
            </div>
            {platform === "desktop" && (
              <div className="flex items-start gap-3">
                <div className="h-8 w-8 rounded-full bg-white/8 border border-white/10 flex items-center justify-center shrink-0">
                  <FolderOpen className="h-4 w-4 text-white/85" strokeWidth={1.8} />
                </div>
                <p className="text-xs text-white/65 leading-relaxed pt-1.5">
                  {t("hintDesktopFolderTip")}
                </p>
              </div>
            )}
          </div>

          <button
            data-testid="hint-dismiss-button"
            onClick={onClose}
            className="mt-3 h-12 w-full rounded-full bg-white text-black font-medium text-sm active:scale-[0.98] transition-transform"
          >
            {t("gotIt")}
          </button>
        </div>
      </div>
    </div>
  );
}
